export const getHelpModalVisible = (state) => state.settings.helpModalVisible;
export const selectRestartingStatus = (state) => state.settings.restarting || false;

export const getUnitsList =  (state) => state.settings.organization.organizationList;

export const getRegister =  (state) => state.settings.register;

export const getOrganization =  (state) => state.settings.organization;

